import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';

const BOT_PATTERN =
  '(CartwheelThumbnailBot|googlebot/|bot|Googlebot-Mobile|Googlebot-Image|Google favicon|Mediapartners-Google|bingbot|slurp|java|wget|curl|Commons-HttpClient|Python-urllib|libwww|httpunit|nutch|phpcrawl|msnbot|jyxobot|FAST-WebCrawler|FAST Enterprise Crawler|biglotron|teoma|convera|seekbot|gigablast|exabot|ngbot|ia_archiver|GingerCrawler|webmon |httrack|webcrawler|grub.org|UsineNouvelleCrawler|antibot|netresearchserver|speedy|fluffy|bibnum.bnf|findlink|msrbot|panscient|yacybot|AISearchBot|IOI|ips-agent|tagoobot|MJ12bot|dotbot|woriobot|yanga|buzzbot|mlbot|yandexbot|purebot|Linguee Bot|Voyager|CyberPatrol|voilabot|baiduspider|citeseerxbot|spbot|twengabot|postrank|turnitinbot|scribdbot|page2rss|sitebot|linkdex|Adidxbot|blekkobot|ezooms|dotbot|Mail.RU_Bot|discobot|heritrix|findthatfile|europarchive.org|NerdByNature.Bot|sistrix crawler|ahrefsbot|Aboundex|domaincrawler|wbsearchbot|summify|ccbot|edisterbot|seznambot|ec2linkfinder|gslfbot|aihitbot|intelium_bot|facebookexternalhit|yeti|RetrevoPageAnalyzer|lb-spider|sogou|lssbot|careerbot|wotbox|wocbot|ichiro|DuckDuckBot|lssrocketcrawler|drupact|webcompanycrawler|acoonbot|openindexspider|gnam gnam spider|web-archive-net.com.bot|backlinkcrawler|coccoc|integromedb|content crawler spider|toplistbot|seokicks-robot|it2media-domain-crawler|ip-web-crawler.com|siteexplorer.info|elisabot|proximic|changedetection|blexbot|arabot|WeSEE:Search|niki-bot|CrystalSemanticsBot|rogerbot|360Spider|psbot|InterfaxScanBot|Lipperhey SEO Service|CC Metadata Scaper|g00g1e.net|GrapeshotCrawler|urlappendbot|brainobot|fr-crawler|binlar|SimpleCrawler|Livelapbot|Twitterbot|cXensebot|smtbot|bnf.fr_bot|A6-Indexer|ADmantX|Facebot|Twitterbot|OrangeBot|memorybot|AdvBot|MegaIndex|SemanticScholarBot|ltx71|nerdybot|xovibot|BUbiNG|Qwantify|archive.org_bot|Applebot|TweetmemeBot|crawler4j|findxbot|SemrushBot|yoozBot|lipperhey|y!j-asr|Domain Re-Animator Bot|AddThis)';

type InitDatadogOptions = {
  service: string;
  env: string;
  isDevelopment: boolean;
};

let isDatadogInitialized = false;

export function initDatadog({
  service,
  env,
  isDevelopment,
}: InitDatadogOptions) {
  if (isDevelopment || isDatadogInitialized) {
    return;
  }

  const isBot = new RegExp(BOT_PATTERN, 'i').test(navigator.userAgent);

  datadogRum.init({
    applicationId: 'edaefc6d-e8d5-46ba-9a18-5752b2b69d19',
    clientToken: 'pub6677cd92dfd8fe784039e7e5ca69e0be',
    site: 'datadoghq.com',
    service,
    env,
    version: '1.0.0',
    sessionSampleRate: isBot ? 0 : 100,
    sessionReplaySampleRate: isBot ? 0 : 100,
    trackSessionAcrossSubdomains: true,
    defaultPrivacyLevel: 'allow',
  });

  datadogLogs.init({
    clientToken: 'pub6677cd92dfd8fe784039e7e5ca69e0be',
    site: 'datadoghq.com',
    service,
    env,
    forwardConsoleLogs: 'all',
    forwardErrorsToLogs: true,
    sessionSampleRate: isBot ? 0 : 100,
    trackSessionAcrossSubdomains: true,
  });

  isDatadogInitialized = true;
}

export function addDatadogAction(
  actionName: string,
  context?: Record<string, unknown>,
) {
  datadogRum.addAction(actionName, context);
}

export function setDatadogUser(user: Record<string, unknown> & { id: string }) {
  datadogRum.setUser(user);
}

export function clearDatadogUser() {
  datadogRum.clearUser();
}
